document.addEventListener('DOMContentLoaded', () => {
    function updateTotal() {
        let total = 0;
        document.querySelectorAll('.quantity').forEach(input => {
            total += parseInt(input.value) || 0;
        });
        document.getElementById('totalBands').textContent = total;
    }

    function updatePreview(row) {
        const logoText = row.querySelector('.logo-text').value;
        const sideText = row.querySelector('.side-text').value;
        row.querySelector('.band-preview').textContent = logoText || 'Logo Side';
        row.querySelectorAll('.band-preview')[1].textContent = sideText || 'Other Side';
    }

    function addNewRow() {
        const table = document.getElementById('orderTable');
        const newRow = table.insertRow(-1);
        newRow.innerHTML = document.querySelector('tr:nth-child(2)').innerHTML;
        attachListeners(newRow);
        updateTotal();
    }

    function attachListeners(row) {
        row.querySelector('.logo-text').addEventListener('input', () => updatePreview(row));
        row.querySelector('.side-text').addEventListener('input', () => updatePreview(row));
        row.querySelector('.quantity').addEventListener('input', updateTotal);
    }

    attachListeners(document.querySelector('tr:nth-child(2)'));

    document.getElementById('addRowButton').addEventListener('click', addNewRow);

    document.querySelector('.checkout-button').addEventListener('click', () => {
        alert('Proceeding to Shopify Checkout');
        window.location.href = '/cart';
    });
});
